import { IBiLink } from '@suvo-bi-lib'

export const MAJOR_NAV_LINKS: IBiLink[] = [
  {
    route: 'overview',
    displayName: 'Overview',
    displayIcon: 'assignments',
  },
]